import { createFileRoute } from '@tanstack/react-router';
import { PaymentsHub } from '@/components/company/payments/payments-hub';

export const Route = createFileRoute('/(app)/company/payments/employee')({
	component: EmployeePaymentsRoute,
});

function EmployeePaymentsRoute() {
	return <PaymentsHub mode="employee" />;
}
